import { state, paginagedState } from './Base.state';

export * from './Base.schema';

export const base = {
  state,
  paginagedState,
};
